import { client } from "../../../Infrastructure/agent";

export const VisualQueryService = {
  getViews: () => client.get("/VisualQuery/views"),
  run: (query) => client.post("/VisualQuery/run", query),
};